import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from '../../store/store'

import { filePeview, ErrorResult} from '../../shared/interfaces'

import { analyzeFile, analyzeAndSignFile  } from '../../services/ovscService'

interface ovscState {
  errorResult: ErrorResult | null ,
  inSignCall: boolean
}

const initialState: ovscState = {
  errorResult: null,
  inSignCall: false
}

const ovscSlice = createSlice({
  name: 'ovscSlice',
  initialState,
  reducers: {
    clearError(state) {
      state.errorResult=null;
    },
    callService(state) {
      state.inSignCall=true;
    },
    ovscCallSuccess(state, action: PayloadAction<ErrorResult|null>) {
      state.errorResult = action.payload;
      state.inSignCall = false;
    },
    ovscCallFailed(state, action: PayloadAction<any>) {
      const res:ErrorResult = { No:-1, Message:action.payload.toString(), AnalysisErrors:[] };
      state.errorResult= res;
      state.inSignCall=false;
    }
  }
})

export const {
  clearError,
  callService,
  ovscCallSuccess,
  ovscCallFailed
} = ovscSlice.actions

export default ovscSlice.reducer

export const analyzeAndSign = (file:filePeview): AppThunk => async dispatch => {
  let actionResult
  try {
    dispatch(callService());
    actionResult = await analyzeAndSignFile(file)
  } catch (err) {
    dispatch(ovscCallFailed(err))
    return;
  }
  dispatch(ovscCallSuccess(actionResult))
}

export const analyze = (file:filePeview): AppThunk => async dispatch => {
  let actionResult
  try {
    dispatch(callService());
    actionResult = await analyzeFile(file)
  } catch (err) {
    dispatch(ovscCallFailed(err))
    return;
  }
  dispatch(ovscCallSuccess(actionResult))
}